import type { LessonRecurringPayload, LessonRecurringTutor, LessonTutorFilters } from '../../model/lessons/interfaces'
import type { ApiResponse } from '@shared/api'

import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

interface TutorsRecurringAvailabilityApiOptions {
  payload: LessonRecurringPayload & LessonTutorFilters & { discipline_id: number }
}

/** `POST /admin-api/tutors/recurring-availability` — how much of the planned pattern each paid tutor can take.
 *  Send the same pattern as the recurring creation, or the percentages will not match what is created. */
export const useTutorsRecurringAvailabilityApi = async (
  options: TutorsRecurringAvailabilityApiOptions,
): Promise<LessonRecurringTutor[] | null> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()

  const url = useAdminRoutes('admin.tutors.recurring-availability')

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return null
    }

    const { data } = await $axios.post<ApiResponse>(url, options.payload)

    return data.data?.tutors ?? []
  } catch (err: unknown) {
    toast.error(getAxiosErrorMessage(err))

    return null
  }
}
